module.exports = {"websocket":{"connections":{"prod":"wss://ddns.itjh.de:4040"},"reconnectTimeInterval":30000}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/config.json
// module id = 23
// module chunks = 0